var map = {
	"./homePage/dianpu.vue": [
		"BdHO",
		10
	],
	"./homePage/dianpuChat.vue": [
		"R0rM",
		3
	],
	"./homePage/goodsDet.vue": [
		"YAx/",
		0,
		9
	],
	"./homePage/index.vue": [
		"xcJn"
	],
	"./homePage/payment.vue": [
		"4TtM",
		0,
		8
	],
	"./homePage/pintuangouDet.vue": [
		"H9Df",
		0,
		20
	],
	"./homePage/placeOrder.vue": [
		"S+E4",
		0,
		5
	],
	"./homePage/productDetails.vue": [
		"iYDf",
		0,
		13
	],
	"./homePage/productList.vue": [
		"lVYd",
		0,
		15
	],
	"./homePage/productList2.vue": [
		"9xIe",
		0,
		19
	],
	"./homePage/shop.vue": [
		"BzzH",
		21
	],
	"./homePage/vueMchat.vue": [
		"2531",
		2
	],
	"./login/login.vue": [
		"W2Q3",
		0,
		7
	],
	"./login/xieyi.vue": [
		"LZ6w",
		18
	],
	"./login/yinsi.vue": [
		"CW6c",
		16
	],
	"./order/empty.vue": [
		"98s3",
		11
	],
	"./order/information.vue": [
		"w2AQ",
		6
	],
	"./order/order.vue": [
		"Vg+r",
		1,
		0
	],
	"./order/orderDetails.vue": [
		"UKK+",
		12
	],
	"./shoppingCar/index.vue": [
		"1loq",
		14
	],
	"./shoppingCar/shopCartOrder.vue": [
		"My7n",
		0,
		4
	],
	"./shoppingGuide.vue": [
		"cziI",
		17
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 23